import React from 'react';
import { XCircle } from 'lucide-react';

/**
 * Enhanced Input component with optional Clear (X) button and Icon.
 * 
 * @param {string} value - Current input value
 * @param {function} onChange - Change handler
 * @param {function} onClear - Clear handler (if provided, shows X button when value exists)
 * @param {React.Component} icon - Lucide icon component to show on the left
 * @param {string} containerClassName - Custom classes for the wrapper div
 * @param {string} className - Custom classes for the input element
 */
export default function AppInput({ 
    value, 
    onChange, 
    onClear, 
    icon: Icon,
    containerClassName = '',
    className = '', 
    ...props 
}) {
    const hasValue = value && String(value).length > 0;

    return (
        <div className={`relative flex items-center w-full ${containerClassName}`}>
            {Icon && (
                <Icon 
                    className="absolute left-3.5 text-gray-400 pointer-events-none" 
                    size={18} 
                />
            )}
            <input
                className={`
                    w-full bg-white border border-gray-200 p-3.5 rounded-2xl font-bold 
                    focus:outline-none focus:border-[#354F38] focus:ring-4 focus:ring-[#354F38]/10 
                    transition 
                    ${Icon ? 'pl-11' : 'pl-4'} 
                    ${onClear ? 'pr-10' : 'pr-4'} 
                    ${className}
                `.trim().replace(/\s+/g, ' ')}
                value={value}
                onChange={onChange}
                {...props}
            />
            {onClear && hasValue && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        onClear();
                    }}
                    className="absolute right-3 p-1 group transition-transform active:scale-90"
                    title="지우기"
                >
                    <XCircle 
                        size={18} 
                        className="text-gray-300 group-hover:text-gray-400 transition-colors fill-gray-100" 
                    />
                </button>
            )}
        </div>
    );
}
